import utils from 'utils'
import * as config from '../../fillOpenManage/ovatBill/components/prefabricatedInvoice/config'

class sendEmailCtrl {
    constructor($scope, httpRequest, $uibModalInstance, items1, logger) {
        $scope.checkRows = items1.checkRows
        $scope.checkIs = items1.checkIs
        $scope.modaldata = {
            email: ''
        }
        // 发送确认提醒 邮箱 取 用户自定义
        httpRequest.get_getUserCustomized(59124).then((res) => {
            if (res.data.value) {
                $scope.modaldata.email = JSON.parse(res.data.value)
            }
        })
        // 确定
        $scope.ok = function ok() {
            if(!$scope.modaldata.email) return logger.logError('邮箱必填')
            let email = $scope.modaldata.email
            const result2 = $scope.modaldata.email && utils.regExpTestEmail($scope.modaldata.email)
            if (email && !result2) {
                // alert('邮箱格式不正确')
                logger.logError('邮箱格式不正确')
                return
            }
            httpRequest.post_saveUserCustomized({
                profileInfo: JSON.stringify($scope.modaldata.email),
                profileType: 59124,
            })
            $uibModalInstance.close($scope.modaldata.email)
        }
        // 关闭
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss('cancel')
        }
    }
}

sendEmailCtrl.$inject = ['$scope', 'httpRequest', '$uibModalInstance', 'items1', 'logger']
export default sendEmailCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/redInkConfirmForm/sendEmailCtrl.js